









import Vue from "vue";
export default Vue.extend({
    props: {
      action: {
        type: String,
        default: 'navigate'
      },
      icon: {
          type: String,
          default: null
      },
      link: {
          type: String,
          default: null
      },
      text: {
          type: String,
          default: ""
      },
      type: {
        type: String,
        default: ""
      }
    },
    computed: {
      to():string | null {
        return this.link ? this.link : ''
      }
    }
});
